<template>
  <div class="modal-container" v-show="show">
    <div class="modal">
      <div class="text-title">
        {{ title }}
      </div>

      <div v-if="articleID != null && commentID == null" class="btn-check">
        <!--글삭제-->
        <div class="cancel-check" @click="cancel">
          <button class="cancel">취소</button>
        </div>
        <div class="confirm-check" @click="deleteArticle(articleID)">
          <button class="check">확인</button>
        </div>
      </div>

      <div v-if="articleID != null && commentID != null" class="btn-check">
        <!--댓글삭제-->
        <div class="cancel-check" @click="cancel">
          <button class="cancel">취소</button>
        </div>
        <div class="confirm-check" @click="deleteComment(articleID, commentID)">
          <button class="check">확인</button>>
        </div>
      </div>

      <div v-if="articleID == null && commentID == 0" class="btn-check2">
        <!-- 작성된 글이 없을때 -->
        <div @click="cancel"><button class="check">확인</button></div>
      </div>

      <div v-if="articleID == null && commentID == null" class="btn-check2">
        <!-- 작성된 댓글이 없을때 -->
        <div @click="cancel"><button class="check">확인</button></div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "modal",
  props: ["show", "title", "articleID", "commentID"],
  methods: {
    deleteArticle(id) {
      firebase
        .database()
        .ref("article")
        .child(id)
        .remove();
      this.$emit("close");
      this.$router.push({ name: "Home", query: { pg: String(1) } });
      if (localStorage.getItem(id));
    },
    deleteComment(aid, cid) {
      firebase
        .database()
        .ref("article/" + aid + "/comment/")
        .child(cid)
        .remove();
      this.$emit("close");
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
@import "Modal.scss";
</style>
